import { useNavigate } from "react-router-dom";
import { Container, FormControlLabel, Radio, RadioGroup, TextField, Typography, Grid } from "@mui/material";
import { useState } from "react";
import useIsMobileView from "../../utils/hooks/useIsMobileView";
import {
  setTesterName,
  setTestInterval,
  setTestPauseDuration,
  setTestSoundRecording,
} from "../../utils/hooks/useTestReducer";
import { isNumeric } from "../../utils/number-utils";
import { TestReducer } from "../../types/test-types";
import VButton from "../Common/VButton";

const TestParameters = (props: { testReducer: TestReducer }) => {
  const IsMobileView = useIsMobileView();
  const navigate = useNavigate();
  const [state, dispatch] = [props.testReducer.state, props.testReducer.dispatch];
  const [errorsState, setErrors] = useState<{
    isIntervalInputInvalid: boolean;
    isPauseInputInvalid: boolean;
  }>({
    isIntervalInputInvalid: false,
    isPauseInputInvalid: false,
  });

  const handleIntervalChange = (interval: string | number): boolean => {
    dispatch(setTestInterval(interval));
    const invalid = interval === "" || !isNumeric(interval) || +interval < 2 || +interval > 10;
    setErrors({
      ...errorsState,
      isIntervalInputInvalid: invalid,
    });

    return invalid;
  };

  const handlePauseChange = (pauseDuration: string | number): boolean => {
    dispatch(setTestPauseDuration(pauseDuration));
    const invalid = pauseDuration === "" || !isNumeric(pauseDuration) || +pauseDuration < 0 || +pauseDuration > 120;
    setErrors({
      ...errorsState,
      isPauseInputInvalid: invalid,
    });

    return invalid;
  };

  const areTestParametersValid = (): boolean => {
    return (
      !handleIntervalChange(state.testParams.testInterval) && !handlePauseChange(state.testParams.testPauseDuration)
    );
  };

  const StartTest = () => {
    if (areTestParametersValid()) {
      navigate("/test");
    }
  };

  return (
    <Container
      disableGutters
      sx={{
        paddingLeft: IsMobileView ? 0 : "2vw",
        height: "100%",
      }}
    >
      <Container
        disableGutters
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center",
          marginTop: IsMobileView ? "2vh" : "0vh",
          backgroundColor: "white",
          borderRadius: "20px",
          py: "5%",
          px: "7%",
        }}
      >
        <Typography sx={styles.subTitle}>Parameetrid</Typography>
        <Grid container rowSpacing={1}>
          <Grid item xs={5} md={5} lg={5} sx={styles.gridNameItem}>
            <Typography>Testi sooritaja:</Typography>
          </Grid>
          <Grid item xs={7} md={7} lg={7}>
            <TextField
              name="patientUuid"
              size="small"
              label="Kood"
              variant="outlined"
              sx={{ width: "100%" }}
              value={state.userCode}
              onChange={(event) => dispatch(setTesterName(event.target.value))}
            />
          </Grid>
          <Grid item xs={5} md={5} lg={5} sx={styles.gridNameItem}>
            <Typography>Intervallid:</Typography>
          </Grid>
          <Grid item xs={7} md={7} lg={7} sx={styles.gridValueItem}>
            <TextField
              name="intervals"
              label="Sekundit"
              size="medium"
              type="number"
              variant="standard"
              helperText="2 - 10"
              InputLabelProps={{ shrink: true }}
              error={errorsState.isIntervalInputInvalid}
              sx={styles.numberInput}
              value={state.testParams.testInterval}
              onChange={(event) => handleIntervalChange(event.target.value)}
            />
          </Grid>
          <Grid item xs={5} md={5} lg={5} sx={styles.gridNameItem}>
            <Typography>Pausi pikkus:</Typography>
          </Grid>
          <Grid item xs={7} md={7} lg={7} sx={styles.gridValueItem}>
            <TextField
              name="pauseDuration"
              label="Sekundit"
              size="medium"
              type="number"
              variant="standard"
              helperText="0 - 120"
              InputLabelProps={{ shrink: true }}
              error={errorsState.isPauseInputInvalid}
              sx={styles.numberInput}
              value={state.testParams.testPauseDuration}
              onChange={(event) => handlePauseChange(event.target.value)}
            />
          </Grid>
          <Grid item xs={5} md={5} lg={5} sx={styles.gridNameItem}>
            <Typography>Salvesta heli:</Typography>
          </Grid>
          <Grid item xs={7} md={7} lg={7} sx={styles.gridValueItem}>
            <RadioGroup
              sx={styles.radioButtonContainer}
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="active"
              name="sound"
              value={state.testParams.testSoundRecording ? "active" : "inactive"}
              onChange={(event) => dispatch(setTestSoundRecording(event.target.value === "active"))}
            >
              <FormControlLabel value="active" control={<Radio />} label="Sees" />
              <FormControlLabel value="inactive" control={<Radio />} label="Väljas" />
            </RadioGroup>
          </Grid>
        </Grid>
      </Container>
      <Container
        disableGutters
        sx={{
          pt: IsMobileView ? "0vh" : "3%",
          marginTop: IsMobileView ? "3%" : "0vh",
          display: IsMobileView ? 0 : "grid",
          alignItems: IsMobileView ? 0 : "end",
        }}
      >
        <VButton
          text="SOORITA TEST &#62;"
          type="outlined"
          onClick={StartTest}
          disabled={errorsState.isPauseInputInvalid || errorsState.isIntervalInputInvalid}
        />
      </Container>
    </Container>
  );
};

export default TestParameters;

const styles = {
  subTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 700,
    color: "black",
    paddingBottom: "5%",
  },
  parameterContainer: {
    py: "1%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  radioButtonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
  },
  gridValueItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  gridNameItem: {
    display: "flex",
    alignItems: "center",
  },
  numberInput: {
    width: "50%",
  },
};
